export const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
        {
            '@type': 'Question',
            name: 'Was kostet HorseDeal?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'HorseDeal kannst Du völlig unverbindlich und kostenlos nutzen. Das Erstellen eines Reiter- oder Pferde-Profils sowie das Versenden von Anfragen ist für alle Mitglieder dauerhaft kostenlos.',
            },
        },
        {
            '@type': 'Question',
            name: 'Was sind Credits?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Wir nutzen Credits als unsere eigene Währung bei HorseDeal. Wenn Du eine Anfrage von einem anderen Mitglied erhältst, kannst Du vor einem Match das gesamte Profil sowie die Übereinstimmung auf Basis unseres Matchings vollständig einsehen. Erst für ein Match, d.h. das Akzeptieren einer Anfrage, werden Credits benötigt. Um noch mehr über unsere Funktionen und Preise zu erfahren, besuche die Seite „Preisgestaltung“.',
            },
        },
        {
            '@type': 'Question',
            name: 'Gibt es bezahlte Funktionen?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Richtig, es gibt bezahlte Funktionen bei HorseDeal. Diese werden mit Credits als Währung bezahlt. Für eine transparente Übersicht über die Kosten und Funktionen besuche die Seite „Preisgestaltung“ und scrolle zum Abschnitt „Wie viele Credits brauche ich?“. Zum Start erhältst Du kostenlose Credits, mit denen Du alle Funktionen risikofrei ausprobieren kannst. Auch später musst Du keine Credits kaufen - Du kannst sie jederzeit durch Rewards wie z. B. Freunde einladen oder Flip & Win kostenlos erhalten. Wenn Du einmal schnell mehr Credits benötigst, kannst Du sie auch ganz einfach als Paket mit 30, 150 oder 300 Credits nachkaufen. Weitere Informationen dazu findest Du ebenfalls auf der Seite „Preisgestaltung“ und scrolle zum Abschnitt „Credit-Pakete“.',
            },
        },
        {
            '@type': 'Question',
            name: 'Wo kann ich meine Credits einsehen?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Einen Überblick über deine gesammelten, erworbenen sowie ausgegebenen Credits erhältst Du auf der Seite „Meine Bilanz“. Melde dich in deinem Konto an und klicke in der Navigation anschliessend auf „Meine Bilanz“.',
            },
        },
        {
            '@type': 'Question',
            name: 'Wofür werden Credits genau benötigt?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Credits benötigst Du primär, um Anfragen anderer Mitglieder zu akzeptieren und so ein Match herzustellen. Bevor Du dich entscheidest, kannst Du das komplette Profil sowie die Übereinstimmung auf Basis unseres Matchings einsehen. Erst wenn Du die Anfrage annimmst, werden Credits eingesetzt. Das Erstellen eines Reiter- oder Pferde-Profils sowie das Versenden von Anfragen ist für alle Mitglieder dauerhaft kostenlos. Um noch mehr über unsere Funktionen und Preise zu erfahren, besuche die Seite „Preisgestaltung“.',
            },
        },
        {
            '@type': 'Question',
            name: 'Verfallen meine Credits irgendwann?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Nein, deine Credits haben kein Ablaufdatum. Einmal erworbene oder erhaltene Credits bleiben dauerhaft in deinem Konto gespeichert und können jederzeit genutzt werden.',
            },
        },
        {
            '@type': 'Question',
            name: 'Welche Zahlungsmethoden gibt es?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Du kannst Credits bequem mit allen gängigen Zahlungsmethoden bezahlen. Dazu gehören Kreditkarten (Visa, Mastercard), Twint, Apple Pay, Google Pay sowie Zahlung auf Rechnung mit Klarna. Je nach Land können weitere Optionen zur Verfügung stehen.',
            },
        },
        {
            '@type': 'Question',
            name: 'Wie kann ich kostenlose Credits erhalten?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Wenn Du dich als neues Mitglied bei HorseDeal registrierst, erhältst Du kostenlose Credits, mit denen Du alle Funktionen risikofrei ausprobieren kannst. Auch später musst Du keine Credits kaufen - Du kannst sie dir jederzeit durch Aktionen wie Freunde einladen oder unser Flip & Win kostenlos sichern.',
            },
        },
        {
            '@type': 'Question',
            name: 'Was sind Anfragen?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Anfragen sind Kontaktaufnahmen zwischen Reiter:innen und Pferdebesitzer:innen auf HorseDeal. Du kannst anderen Mitgliedern eine Anfrage senden, wenn dich ihr Profil interessiert. Wenn Du selbst eine Anfrage erhältst, kannst Du vor der Annahme das gesamte Profil sowie die Übereinstimmung auf Basis unseres Matchings einsehen. Erst mit deiner Annahme entsteht ein Match und ihr könnt direkt miteinander kommunizieren. In unserem Hilfe-Center zeigen wir dir Schritt für Schritt, wie Du Anfragen akzeptieren kannst.',
            },
        },
        {
            '@type': 'Question',
            name: 'Was sind Ansichten?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Ansichten zeigen dir, wie oft dein Reiter- oder Pferde-Profil von anderen Mitgliedern aufgerufen wurde. Dabei siehst Du nicht nur die Anzahl der Ansichten, sondern auch genau, wer dein Profil besucht hat. Profile, die das Zusatzpaket „Privates Profil“ nutzen, werden in der Ansicht allerdings nicht aufgeführt. So erhältst Du einen transparenten Überblick darüber, wie sichtbar dein Profil ist und welches Interesse es in der Community weckt. In unserem Hilfe-Center zeigen wir dir Schritt für Schritt, wie Du Ansichten aufdecken kannst.',
            },
        },
        {
            '@type': 'Question',
            name: 'Was ist ein „Geschenktes Match“?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Die Funktion „Geschenktes Match“ ermöglicht es dir, einem anderen Mitglied 30 Credits zu schenken, damit es deine Anfrage kostenlos akzeptieren kann - so steigerst Du deine Chancen auf ein Match! Wenn die Anfrage nicht angenommen wird oder nach 14 Tagen abläuft, erhältst Du deine Credits automatisch zurück. In unserem Hilfe-Center zeigen wir dir Schritt für Schritt wie Du die Funktion aktivieren kannst.',
            },
        },
        {
            '@type': 'Question',
            name: 'Was ist das Zusatzpaket „Privates Profil“?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Mit dem Zusatzpaket „Privates Profil“ bleibt dein Profil trotz Verfügbarkeit oder Veröffentlichung unsichtbar in den Suchergebnissen und auf der Karte. Andere Mitglieder können nicht sehen, ob Du ihr Profil besucht oder es zu deinen Favoriten hinzugefügt hast. In unserem Hilfe-Center zeigen wir dir Schritt für Schritt, wie Du dieses Zusatzpaket für dein Reiter- oder Pferde-Profil aktivieren kannst.',
            },
        },
        {
            '@type': 'Question',
            name: 'Was ist das Zusatzpaket „Anonymes Profil“?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Mit dem Zusatzpaket „Anonymes Profil“ bleibt dein Name sowie der Name deines Pferdes für andere Mitglieder verborgen, bis Du ihre Anfrage akzeptierst. Auch Fotos und Videos deines Profils sind erst nach deiner Zustimmung sichtbar. Für mehr Vertrauen kannst Du bei proaktiven Anfragen entscheiden, die Anonymität optional aufzuheben. In unserem Hilfe-Center zeigen wir dir Schritt für Schritt, wie Du dieses Zusatzpaket für dein Reiter-oder Pferde-Profil aktivieren kannst.',
            },
        },
        {
            '@type': 'Question',
            name: 'Was ist das Zusatzpaket „Social Boost“?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Mit dem Zusatzpaket „Social Boost“ wird dein Profil aktiv auf Social Media im Umkreis von 15 km um deine Wohn- oder Stalladresse beworben. So erhältst Du deutlich mehr Sichtbarkeit bei passenden Reiter:innen und Pferdebesitzer:innen in deiner Nähe. In unserem Hilfe-Center zeigen wir dir Schritt für Schritt, wie Du dieses Zusatzpaket für dein Reiter- oder Pferde-Profil aktivieren kannst.',
            },
        },
    ],
};
